import Resource from '../Resource'

export default class SelfTestAnswer extends Resource {
  static ENDPOINT = '/api/test/selftest'

  constructor (args) {
    super()
    this.extend(args)
  }

  static create (training, student, code, qunits) {
    const units = []
    qunits.forEach(u => {
      const unit = {
        code: u.code,
        answer: Array(u.content.length)
      }
      units.push(unit)
    })
    return new SelfTestAnswer({ training, student, code, units })
  }

  mark (test) {
  }
}
